'use client'
import { useTransition } from 'react'
import { useRouter } from 'next/navigation'
import Pagination from '@/components/atoms/Pagination'
import { ProductCard } from '@/components/molecules/ProductCard'
import { ProductsFilter } from '@/components/molecules/ProductsFilter'
import { ProductDataType } from '@/interfaces/pages'
import { ProductsSkeleton } from '@/components/molecules/ProductsSkeleton'

interface Option {
  slug: string
  title: string
}

interface PaginateProductsClientProps {
  products: ProductDataType['product'][]
  sections: Option[]
  tags: Option[]
  initialCategories: Option[]
  manufacturers: Option[]
  filters: {
    q: string
    section: string
    category: string
    tag: string
    manufacturer: string
  }
  page: number
  totalPages: number
  basePath?: string
  hideTags?: boolean
}

export function PaginateProductsClient({
  products,
  sections,
  tags,
  initialCategories,
  manufacturers,
  filters,
  page,
  totalPages,
  basePath = '/products',
  hideTags = false,
}: PaginateProductsClientProps) {
  const router = useRouter()
  const [isPending, startTransition] = useTransition()
  const { q, section, category, tag, manufacturer } = filters

  const handleNavigate = (url: string) => {
    startTransition(() => {
      router.push(url, { scroll: true })
    })
  }

  return (
    <>
      <div className="card-banner-section-filters">
        <ProductsFilter
          initialSections={sections}
          initialTags={tags}
          initialCategories={initialCategories}
          initialManufacturers={manufacturers}
          initialQuery={q}
          initialSection={section}
          initialCategory={category}
          initialTag={tag}
          initialManufacturer={manufacturer}
          onNavigateTo={handleNavigate}
          isNavigating={isPending}
          basePath={basePath}
          hideTags={hideTags}
        />
      </div>
      <div className="card-banner-section-items">
        {isPending ? (
          <ProductsSkeleton />
        ) : (
          <>
            <div className="card-banner-section-items-list">
              {products.length > 0 ? (
                products.map((product, index) => (
                  <div key={product.id}>
                    <ProductCard product={product} priority={index === 0} />
                  </div>
                ))
              ) : (
                <div className="card-banner-section-items-not-found">
                  <p>Nenhum produto encontrado com os filtros selecionados.</p>
                </div>
              )}
            </div>
            {products.length > 0 && (
              <Pagination currentPage={page} totalPages={totalPages} />
            )}
          </>
        )}
      </div>
    </>
  )
}
